import { memo } from "react";
import type { BaseAirport } from "@jb-dotcom/api/odb";
import { TextHighlight } from "./text-highlight";
import { ListBoxItem } from "@jetblue/kit/input-combobox";

export const Airport = memo(
  ({
    name,
    indent = false,
    inputValue,
    code,
  }: Pick<BaseAirport, "name" | "needle" | "code"> & {
    inputValue?: string | undefined;
    indent?: boolean | undefined;
  }) => (
    <ListBoxItem
      className="data-[indent='true']:before:content-['\2014_']"
      data-indent={indent}
      id={code}
      key={code}
      textValue={name}
    >
      <TextHighlight highlight={inputValue}>{name}</TextHighlight>
    </ListBoxItem>
  ),
);

Airport.displayName = "Airport";
